import type { FC } from "react";

import { DealerChangeLogSearchForm } from "src/app/features/DealerChangeLog/components/forms/DealerChangeLogSearchForm";
import { DealerChangeLogsTable } from "src/app/features/DealerChangeLog/components/tables/DealerChangeLogTable";
import type { DealerChangeLogList } from "src/app/features/DealerChangeLog/types/DealerChangeLogList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const DealerChangeLogsPage: FC<NoneOwnProps> = () => {
    const table = <DealerChangeLogsTable />;
    const searchForm = <DealerChangeLogSearchForm />;
    const hasAccess = canAccess(ResourceName.DEALER_CHANGE_LOGS, "canRead");

    return (
        <PageLayout name="DealerChangeLogs_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.dealerChangeLog" />
                    <ResourceManager<DealerChangeLogList>
                        useDataGroup
                        dataMapperKey="DealerChangeLogsTableData"
                        resource={ResourceName.DEALER_CHANGE_LOGS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
